import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 13l-5 -10l-5 10m6 0l4 8l4 -8","key":"svg-0"}]]

const IconBrandStrava = createReactComponent('outline', 'brand-strava', 'BrandStrava', __iconNode);

export default IconBrandStrava;